import { render, staticRenderFns } from "./AcoesDesclassificar.vue?vue&type=template&id=5a1fd47f&scoped=true"
import script from "./AcoesDesclassificar.vue?vue&type=script&lang=js"
export * from "./AcoesDesclassificar.vue?vue&type=script&lang=js"
import style0 from "./AcoesDesclassificar.vue?vue&type=style&index=0&id=5a1fd47f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fd47f",
  null
  
)

export default component.exports